<template>
    <v-card class="array-view" elevation="1">
        <v-data-table
            class="array-view__table"
            item-key="id"
            :headers="tableHeaders"
            :items="items"
            :items-per-page="size"
            :loading="isLoading"
            :sort-by="sortBy"
            :sort-desc="sortDesc"
            :server-items-length="items ? items.length : 0"
            hide-default-footer
            disable-pagination
            :mobile-breakpoint="0"
            @update:options="onOptionsChange"
        >
            <template slot="item" slot-scope="props">
                <tr>
                    <td
                        v-for="header in headers"
                        :key="header.value"
                    >
                        <span v-if="header.text === 'categories'"> {{ getCategories(props.item) }}</span>
                        <span v-else-if="header.value === 'publishedOnSocial'" class="social-cell">
                            <v-switch
                                v-model="props.item.publishedOnSocial"
                                color="primary"
                                inset
                                dense
                                hide-details
                                class="mt-0 pt-0"
                                @change="handleClick('togglePublishedOnSocial', props.item)"
                            />
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon small v-bind="attrs" v-on="on" @click="getMatchStats(props.item)">
                                        <v-icon small>mdi-eye-outline</v-icon>
                                    </v-btn>
                                </template>
                                <span>Score &amp; MVP for the post</span>
                            </v-tooltip>
                        </span>
                        <span v-else-if="header.value === 'leagues'"> {{ props.item.leagues && props.item.leagues.length ? props.item.leagues.map(league => league.title).join(', ') : '-' }}</span>
                        <span v-else-if="header.text === 'League'"> {{ props.item[header.value] ? props.item[header.value].title : '-' }}</span>
                        <span v-else-if="header.text === 'Cup'"> <v-icon :color="props.item['cup'] ? 'green' : 'red'"> {{ props.item['cup'] ? 'mdi-check' : 'mdi-close' }}</v-icon> </span>
                        <span v-else-if="header.value === 'noOfMatches'"> {{ `#MatchesRule${props.item[header.value].slice(-1)}` }}</span>
                        <span v-else-if="header.text === 'Free'"> <v-icon :color="props.item[header.value] ? 'green' : 'red'"> {{ props.item[header.value] ? 'mdi-check' : 'mdi-close' }} </v-icon> </span>
                        <span v-else-if="header.text === 'Image' || header.text === 'History Points Icon Image'"> <v-img contain width="200px" height="100px" :src="props.item[header.value]" /></span>
                        <v-chip
                            v-else-if="header.chip && header.chip(props.item)"
                            x-small
                            dark
                            :color="header.chip(props.item).color"
                            :title="header.chip(props.item).title"
                        >
                            <v-icon v-if="header.chip(props.item).icon" x-small left>{{ header.chip(props.item).icon }}</v-icon>{{ header.chip(props.item).text }}
                        </v-chip>
                        <span v-else-if="header.chip" class="grey--text">–</span>
                        <v-chip v-else-if="type === 'teamApplication' && header.value === 'status'" x-small dark :color="statusColors[props.item.status]">{{ props.item.status }}</v-chip>
                        <span v-else-if="header.text.includes('Date')"> {{ getDate(props.item[header.value], type === 'match') }}</span>
                        <!-- a flag that changes right from the list (e.g. the active of a player) -->
                        <v-switch
                            v-else-if="header.toggle"
                            v-model="props.item[header.value]"
                            color="green"
                            inset
                            dense
                            hide-details
                            class="mt-0 pt-0"
                            :title="props.item[header.value] ? 'Active' : 'Inactive'"
                            @change="handleClick(`toggle:${header.value}`, props.item)"
                        />
                        <v-icon v-else-if="typeof props.item[header.value] === 'boolean'" small :color="props.item[header.value] ? 'green' : 'red'">
                            {{ props.item[header.value] ? 'mdi-check-circle' : 'mdi-close-circle' }}
                        </v-icon>
                        <span v-else-if="header.subLevel">{{ props.item[header.value] ? props.item[header.value][header.subLevel] : '-' }}</span>
                        <span v-else>{{ props.item[header.value] }}</span>
                    </td>
                    <td v-if="!hideActions || deleteAction" class="text-right actions-cell">
                        <v-tooltip v-if="type === 'match'" bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon small v-bind="attrs" v-on="on" @click="$router.push( `/stats/match/${props.item.id}`)">
                                    <v-icon small>mdi-chart-bar</v-icon>
                                </v-btn>
                            </template>
                            <span>Stats</span>
                        </v-tooltip>
                        <!-- the scoresheet, once the match has a score -->
                        <v-tooltip v-if="type === 'match' && (props.item.scoreTeam1 || props.item.scoreTeam2)" bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon small v-bind="attrs" v-on="on" @click="openSheet(props.item)">
                                    <v-icon small>mdi-clipboard-text-outline</v-icon>
                                </v-btn>
                            </template>
                            <span>Φύλλο αγώνα</span>
                        </v-tooltip>
                        <!-- extra buttons of the page, before Edit -->
                        <slot name="row-actions" :item="props.item" />
                        <v-tooltip v-if="!hideActions" bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon small v-bind="attrs" v-on="on" @click="handleClick('edit', props.item)">
                                    <v-icon small>mdi-pencil</v-icon>
                                </v-btn>
                            </template>
                            <span>Edit</span>
                        </v-tooltip>
                        <delete-button :type="false" color="red darken-1" @delete-entry="onDelete(props.item, localPage)" />
                    </td>
                </tr>
            </template>
        </v-data-table>
        <custom-dialog :dialog="showDialog" @update="showDialog = !showDialog" />
        <match-sheet v-if="type === 'match'" v-model="sheetOpen" :match-id="sheetMatchId" />
        <!-- what goes into the social media post of a match: final score and MVP -->
        <v-dialog v-if="match" v-model="matchDetailsDialog" max-width="640">
            <v-card class="match-post">
                <div class="match-post__band">
                    <span class="match-post__competition">{{ getMatchTitle() }}</span>
                    <span>{{ match.customRoundText || `Round ${match.round}` }} · {{ getDate(match.matchDate, true) }}</span>
                </div>
                <v-card-text class="match-post__score">
                    <span class="match-post__team">{{ match.team1.name }}</span>
                    <span class="match-post__points">{{ match.team1Score }} - {{ match.team2Score }}</span>
                    <span class="match-post__team">{{ match.team2.name }}</span>
                </v-card-text>
                <v-card-text>
                    <div class="form-section-title"><v-icon small>mdi-star-outline</v-icon>MVP</div>
                    <div class="text-body-1">{{ getMatchMvp() }}</div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="matchDetailsDialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <div v-if="totalPages" class="array-view__footer">
            <v-pagination
                v-model="localPage"
                class="array-view__pagination"
                :length="totalPages"
                total-visible="7"
                color="black"
                circle
                @input="paginationChange"
            />
            <div class="array-view__size">
                <span class="text-caption grey--text text--darken-1 mr-2">Rows per page</span>
                <v-select
                    v-model="localSize"
                    :items="sizes"
                    outlined
                    dense
                    hide-details
                    return-object
                    @input="sizeChange"
                />
            </div>
        </div>
    </v-card>
</template>

<script>
    import CustomDialog from '@/components/Dialog'
    import momentTimezone from 'moment-timezone'
    import DeleteButton from '@/components/DeleteButton'
    import MatchSheet from '@/components/MatchSheet'
    import matchService from '@/services/match'

    export default {
        components: { CustomDialog, DeleteButton, MatchSheet },
        props: {
            items: {
                type: Array,
                default: null
            },
            headers: {
                type: Array,
                default: null
            },
            totalPages: {
                type: Number,
                default: null
            },
            page: {
                type: Number,
                default: null
            },
            size: {
                type: Number,
                default: null
            },
            type: {
                type: String,
                default: null
            },
            hideActions: {
                type: Boolean,
                default: false
            },
            deleteAction: {
                type: Boolean,
                default: false
            },
            // server-side sort; ArrayView only emits sortChange, the parent refetches
            sortBy: {
                type: String,
                default: null
            },
            sortDesc: {
                type: Boolean,
                default: false
            }
        },
        data: () => {
            return {
                localPage: 1,
                localSize: 10,
                sizes: [5, 10, 30, 60, 100],
                message: 'Please verify your ',
                role: '',
                showDialog: false,
                sheetOpen: false,
                sheetMatchId: null,
                images: [
                    { url: 'https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/852099ce-b105-48e4-b97a-5b6fd14d7ddf/%CE%B1%CE%BD%CE%B4%CF%81%CE%B9%CE%BA%CE%BF-%CF%80%CE%B1%CF%80%CE%BF%CF%85%CF%84%CF%83%CE%B9-air-max-270-fFBpMM.png' },
                    { url: 'https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5,q_80/20784a41-1187-4979-af37-64eea1843fd6/%CE%B1%CE%BD%CE%B4%CF%81%CE%B9%CE%BA%CE%BF-%CF%80%CE%B1%CF%80%CE%BF%CF%85%CF%84%CF%83%CE%B9-air-max-270-fFBpMM.png' },
                    { url: 'https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5,q_80/fa3de888-3106-4f49-a1a0-53f3e6864bf6/%CE%B1%CE%BD%CE%B4%CF%81%CE%B9%CE%BA%CE%BF-%CF%80%CE%B1%CF%80%CE%BF%CF%85%CF%84%CF%83%CE%B9-air-max-270-fFBpMM.png' },
                    { url: 'https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5,q_80/e46d4b68-5974-4781-b5f9-f317c50f87b6/%CE%B1%CE%BD%CE%B4%CF%81%CE%B9%CE%BA%CE%BF-%CF%80%CE%B1%CF%80%CE%BF%CF%85%CF%84%CF%83%CE%B9-air-max-270-fFBpMM.png' },
                    { url: 'https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/852099ce-b105-48e4-b97a-5b6fd14d7ddf/%CE%B1%CE%BD%CE%B4%CF%81%CE%B9%CE%BA%CE%BF-%CF%80%CE%B1%CF%80%CE%BF%CF%85%CF%84%CF%83%CE%B9-air-max-270-fFBpMM.png' }
                ],
                actionsHeader: [
                    {
                        text: '',
                        value: 'actions',
                        sortable: false,
                        align: 'end'
                    }
                ],
                statusColors: { pending: 'amber darken-2', accepted: 'green', rejected: 'red' },
                isLoading: true,
                matchDetailsDialog: false,
                match: null
            }
        },
        computed: {
            tableHeaders() {
                // nested columns (team.name etc.) are not sortable: the backend combines DISTINCT with the sort
                const headers = this.headers.map(header => ({
                    ...header,
                    sortable: header.sortable !== false && !header.subLevel
                }))
                return this.hideActions && !this.deleteAction ? headers : headers.concat(this.actionsHeader)
            }
        },
        watch: {
            items() {
                if (Array.isArray(this.items)) {
                    this.isLoading = false
                }
            },
            page() {
                this.localPage = this.page
            }
        },
        created() {
            this.localPage = this.page
            this.localSize = this.size
        },
        methods: {
            openSheet(item) {
                this.sheetMatchId = item.id
                this.sheetOpen = true
            },
            onDelete(item, page, parent) {
                this.$emit('onDelete', item, page, parent)
            },
            onOptionsChange(options) {
                const sortBy = options.sortBy.length ? options.sortBy[0] : null
                const sortDesc = sortBy ? !!options.sortDesc[0] : false
                if (sortBy !== this.sortBy || sortDesc !== this.sortDesc) {
                    this.$emit('sortChange', { sortBy, sortDesc })
                }
            },
            handleClick(action, item) {
                this.$emit('handleClick', action, item)
            },
            paginationChange() {
                this.$emit('paginationChange', this.localPage, this.localSize)
            },
            sizeChange() {
                this.localPage = 1
                this.paginationChange()
            },
            // the player of the winning team with the best PIR
            getMatchMvp() {
                if (this.match.team1Score === this.match.team2Score) {
                    return 'No MVP for a draw match'
                }
                const winner = this.match.team1Score > this.match.team2Score ? this.match.team1 : this.match.team2
                const players = winner.players.filter(player => player.stats && player.stats.length > 0)
                if (!players.length) {
                    return 'No stats for this match'
                }
                const mvp = players.reduce((best, player) => Number(player.stats[0].pir) > Number(best.stats[0].pir) ? player : best, players[0])
                const stats = mvp.stats[0]
                const name = mvp.surname ? `${mvp.name} ${mvp.surname}` : mvp.name
                return `#${mvp.alternativeJersey ? mvp.alternativeJersey : mvp.jersey} ${name} (${mvp.position}) - pir: ${stats.pir} - points: ${stats.points} - rebounds: ${stats.rebounds} - assists: ${stats.assists} - steals: ${stats.steals} - blocks: ${stats.blockedShots}`
            },
            getMatchTitle() {
                if (this.match.cupLeague) {
                    return this.match.cupLeague.title
                }
                return this.match.league ? this.match.league.title : 'Friendly'
            },
            getMatchStats(item) {
                matchService.getMatchStats(item.id).then((response) => {
                    this.match = response.data
                    this.matchDetailsDialog = true
                })
            },
            getCategories(item) {
                let categories = []
                item.categories.forEach(element => { categories.push(element.alias) })
                return categories.join(', ')
            },
            getDate(date, isMatch) {
                return isMatch ? momentTimezone(date).tz('Europe/Athens').format('DD/MM/YYYY HH:mm').toString() : momentTimezone(date).tz('Europe/Athens').format('DD/MM/YYYY').toString()
            }
        }
    }
</script>

<style scoped>
    .array-view__table ::v-deep th {
        white-space: nowrap;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.7) !important;
        background: #fafafa;
    }

    .array-view__table ::v-deep tbody tr:hover {
        background: #f0faf8 !important;
    }

    .social-cell {
        display: inline-flex;
        align-items: center;
        gap: 4px;
    }

    .match-post__band {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        gap: 8px;
        padding: 12px 20px;
        background: #232323;
        border-bottom: 3px solid #03e5b7;
        color: rgba(255, 255, 255, 0.75);
        font-size: 0.85rem;
    }

    .match-post__competition {
        color: #fff;
        font-family: 'Squada One', Arial, sans-serif;
        font-size: 1.1rem;
        letter-spacing: 0.04em;
        text-transform: uppercase;
    }

    .match-post__score {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 16px;
        padding-top: 20px !important;
        text-align: center;
    }

    .match-post__team {
        flex: 1;
        font-weight: 600;
        font-size: 1rem;
        color: rgba(0, 0, 0, 0.87);
    }

    .match-post__points {
        font-family: 'Squada One', Arial, sans-serif;
        font-size: 2.2rem;
        color: #232323;
    }

    .actions-cell {
        white-space: nowrap;
        width: 1%;
    }

    .array-view__footer {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        gap: 8px 24px;
        padding: 8px 16px;
        border-top: 1px solid rgba(0, 0, 0, 0.08);
    }

    .array-view__pagination {
        flex: 1 1 auto;
    }

    .array-view__size {
        display: flex;
        align-items: center;
    }

    .array-view__size .v-select {
        width: 90px;
    }
</style>
